var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "32",
          height: "32",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#ffe252",
          d:
            "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z"
        }
      }),
      _c("g", { attrs: { fill: "#7fdecb" } }, [
        _c("path", {
          attrs: {
            d:
              "m22.034 5.44-.046-.046c0 .091.091.137.046.046zm3.201 1.143c-.046.046 0 .137.046.046 0 0 0-.046-.046-.046z"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M25.28 6.628c.046 0 0-.046 0 0zM22.034 5.44c.046-.046 0-.046 0 0zm3.886.457.046.091c.046 0-.046-.046-.046-.091z"
          }
        })
      ]),
      _c("path", {
        attrs: {
          fill: "#ffe252",
          d:
            "M28.8 9.189c.046 0 .046 0 .046-.046-.046 0-.046 0-.046.046zm-1.051-4.983c.046-.046 0-.046 0 0zm-4.846-1.829v-.046c-.046 0-.046 0 0 .046zm-.64 2.286c.046-.046-.046-.046-.091-.046l.091.046zm7.725 4.16h.046c0-.046-.046 0-.046 0z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#4868fd",
          d:
            "M13.257 5.211H7.04a1.854 1.854 0 0 0-1.874 1.874v6.171A1.85 1.85 0 0 0 7.04 15.13h6.217a1.854 1.854 0 0 0 1.874-1.874v-6.17a1.883 1.883 0 0 0-1.874-1.874zm0 12.023H7.04a1.854 1.854 0 0 0-1.874 1.874v6.171c0 1.051.823 1.874 1.874 1.874h6.217a1.854 1.854 0 0 0 1.874-1.874v-6.171c0-1.006-.869-1.874-1.874-1.874zm11.977 0h-6.171a1.85 1.85 0 0 0-1.874 1.874v6.171c0 1.051.823 1.874 1.874 1.874h6.171a1.854 1.854 0 0 0 1.874-1.874v-6.171a1.882 1.882 0 0 0-1.874-1.874z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#7fdecb",
          d:
            "M25.28 5.211h-6.171a1.854 1.854 0 0 0-1.874 1.874v6.171c0 1.052.823 1.874 1.874 1.874h6.171a1.854 1.854 0 0 0 1.874-1.874v-6.17a1.854 1.854 0 0 0-1.874-1.874z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#02016f",
          d:
            "M30.537 9.92c.137.091-.137-1.463-.412-1.143-.046 0 0-.046 0 0h-.046c.046-.366 0-.046-.091-.091.046.137-.457.32-.366.137.046-.046.091-.137.137-.046.046-.046.137-.137.046-.229.046.091-.137.046-.046.091-.046-.046-.091 0-.137-.046.046.137-.183.229-.137.091a11.63 11.63 0 0 0-1.508.503h-.046.046c-.091.046-.091-.046-.091.091-.046-.046-.046.046-.091-.046 0 .046-.091.046-.091.137-.046 0-.091.046-.091-.046 0 .091-.091.091-.091 0-.046.137-.229.137-.366.137-.091 0-.229 0-.274.091 0-.046-.046-.046-.046-.046-.046.046-.091 0-.137.091 0-.091-.046 0-.046-.091-.046.046-.046.091-.046.183-.046-.046-.137.091-.091 0-.594.091-.594.549-.503.914.183.594.457.366 1.051.274h.091v.046c.32.091.32-.32.366-.229.549.137.64-.091.869-.091h.091c-.091-.091.046-.046 0-.137.32.137.366-.229.64 0-.046-.046.137-.046.046-.137.457.183.686-.274 1.189-.137-.046-.046 0-.046 0-.046v-.046c.091.046.183.046.229-.046h-.046c.046-.046 0-.091 0-.137zm-6.354-7.223h-.046c.091-.091.091-.183.046-.229v.046c-.046-.046-.091-.046-.137-.046.137-.137-1.417-.457-1.143-.183-.274-.274-.046-.046-.137 0 .32.229-.274.594-.046.274 0 .091-.091-.274-.183-.137.091 0-.046.091.046.091-.091 0-.046.046-.137.091.137.046.091.274 0 .137-.183.503-.229 1.006-.366 1.417h.046c0 .091-.091 0 .046.091-.091 0 0 .046-.091.046.046.046 0 .091.091.137 0 0-.046.046 0 .046h-.046c.091.046.046.137-.046.046.137.137-.183.457-.137.594h-.046v.046c0 .046-.046.046 0 .091-.046-.046-.046.046-.091 0 0 .046.046.091.137.137-.046 0-.046.046 0 .091-.046 0-.046 0-.046-.046-.091.091 0 .229-.091.366.137-.091-.091.229 0 .229.32-.183.137.32.32.091-.091.183.183 0 .229.091.137-.091.594.137.64-.183.046-.183.046-.32.091-.366 0-.046.137-.091.091-.183.137-.046.091-.183.046-.274s-.091-.137-.046-.091c.411-.32.229-.503.366-.686l.046-.046c-.091.046 0-.046-.091-.046.274-.183 0-.411.274-.503-.091 0 .046-.137-.091-.091.411-.32.183-.731.503-1.051 0 0 0 .046 0 0zM22.08 5.44s-.046 0 0 0c0 .046-.091.046-.091-.046a.16.16 0 0 0 .091.046c0-.046-.046-.046 0 0zm.823-3.109v.046c-.046-.046-.046-.046 0-.046zm-.366.503c-.046 0 0 0 0 0zm-.274 1.829-.046-.091c0 .046.091 0 .046.091zm3.84 2.743c0-.046.137-.046.183-.137v.046c.32-.091.137-.457.183-.366.412-.091.503-.229.594-.366l.137-.137c.046 0 .046-.046.091-.046-.137 0 0-.046-.091-.091.366-.046.228-.411.548-.32-.046-.046.091-.091 0-.137.457-.091.457-.594 1.006-.731-.046 0-.046 0 0-.046l-.046-.046c.091 0 .183-.046.183-.137v.046c0-.046-.046-.046-.091-.091.137-.046-.823-1.326-.869-.777l-.046.046c0-.046-.046-.137-.137-.183v.091c.137-.046.137.091 0 .046.046.137-.32.503-.32.32 0-.046.046-.183.091-.091 0-.046.046-.183-.046-.229.091.046-.091.091 0 .137-.091-.046-.046 0-.137 0 .091.091-.046.32-.091.137-.411.366-.731.777-1.051 1.097l-.046.046h-.046.046c-.091.137-.091 0-.046.137-.046-.046-.046.046-.091 0 0 .046-.046.091 0 .183-.046 0-.046.091-.091 0 .046.091-.046.137-.046.046.046.229-.412.32-.457.503-.046 0-.046 0-.046-.046-.046.046-.091.046-.091.137-.046-.091-.046.046-.046-.046-.046.046 0 .137.046.183-.091 0-.046.137-.091 0-.091.046-.137.229-.274.274.137.046-.229.137-.091.229.183-.046.229.274.091.274.137.091.046.046.274.229.366.137.274.457.686.091.046-.183.137-.091.229-.274zm1.691-3.246c-.046 0 0 0 0 0zm-.594.274c-.046 0-.046 0 0 0zm-.274.594c-.046 0-.046 0 0 0zM25.28 6.674c0-.046 0-.046 0 0s-.091 0-.046-.046.046 0 .046.046c.046-.046 0-.091 0 0zm.64-.686-.046-.091c.046.046.137.091.046.091z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }